import { BrandLoader } from '@/components/brand-loader'

export default function Loading() {
  return (
    <div className="fixed inset-0 z-50 flex h-screen w-screen items-center justify-center overflow-hidden bg-background">
      <BrandLoader />
    </div>
  )
}
